import styled from "styled-components";

export const PersonaVideoContainer = styled.div`
  height: 100%;
  width: 100%;
  font-size: 0;

  video {
    display: block;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
